import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap-icons/font/bootstrap-icons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

function RootComponent() {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 2000);
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div className="text-center text-light">
                <img id="loading" src="/images/chaos.png" alt="loading" />
                <div className="lead mt-5">LOADING</div>
            </div>
        );
    }

    return (
        <React.StrictMode>
            <App />
        </React.StrictMode>
    )
}

root.render(<RootComponent />);

reportWebVitals();
